import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import '../../index.css'
import Section5OrangeBalls from '../../assets/images/Section5OrangeBalls.png'
import Section5Icon1 from '../../assets/images/Section5Icon1.png'
import Section5Icon2 from '../../assets/images/Section5Icon2.png'
import Section5Icon3 from '../../assets/images/Section5Icon3.png'
import Section5Icon4 from '../../assets/images/Section5Icon4.png'
import Section5Icon5 from '../../assets/images/Section5Icon5.png'
import LandingPageModal from 'components/Modal'
import { Button } from 'components/UI'
import { useNavigate } from 'react-router'

import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
// import Modal from './Modal'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const Section5 = () => {
  const [, setIsMobileMenuOpen] = useState(false)
  const [modalData, setModalData] = useState({ isOpen: false, type: '' })

  const navigate = useNavigate()

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600)
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Open modal
  const handleModalOpen = (type) => {
    setModalData({ isOpen: true, type })
    setIsMobileMenuOpen(false)
  }

  // Close modal
  const handleModalClose = () => {
    setModalData({ isOpen: false, type: '' })
  }

  const { ref: Section5Ref, inView: Section5InView } = useInView({ triggerOnce: true })

  const fadeInUpVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.9 } },
  }

  const steps = [
    {
      icon: Section5Icon1,
      title: 'Find Your Tutor',
      desc: 'Use our filters to explore our network of expert tutors and find the perfect fit for you.',
      delay: 0.6,
    },
    {
      icon: Section5Icon2,
      title: 'Flexible Learning',
      desc: 'Choose what to learn and when to learn it. Tailor your education to your goals.',
      delay: 0.8,
    },
    {
      icon: Section5Icon3,
      title: 'Book a Class',
      desc: 'Top up your account, book your lesson and get ready to learn.',
      delay: 1,
    },
    {
      icon: Section5Icon4,
      title: 'Visit Your Class',
      desc: 'Your virtual class will be ready. Just join and your tutor will be ready for you.',
      delay: 1.2,
    },
    {
      icon: Section5Icon5,
      title: 'Master Your Skills',
      desc: 'Gain all the skills you wanted with the help of our amazing tutors.',
      delay: 1.4,
    },
  ]

  return (
    <motion.section
      ref={Section5Ref}
      variants={fadeInUpVariant}
      initial="hidden"
      animate={Section5InView ? 'visible' : 'hidden'}
      className="w-full  py-20 flex flex-col items-center justify-center px-6 lg:px-12 gap-8"
    >
      {/* Heading */}
      <motion.h2
        variants={fadeInUpVariant}
        transition={{ delay: 0.2 }}
        className="font-roboto font-bold text-[30px] leading-[120%] text-center text-gray-900"
      >
        How to Get Started
      </motion.h2>

      {/* Steps with decorative line */}
      <div
        className="relative w-full overflow-x-auto max-w-[1250px] snap-x snap-mandatory [scrollbar-width:none] [-ms-overflow-style:none]
        [&::-webkit-scrollbar]:hidden lg:overflow-visible"
      >
        {isMobile ? (
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            slidesPerView={1}
            slidesPerGroup={1}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 14000, disableOnInteraction: false }}
            loop={true}
            centeredSlides={true} // ✅ Ensures each slide is centered
            className="CarouselAboutUs-Swiper "
          >
            {steps.map((step) => (
              <SwiperSlide className=" p-2">
                <motion.li
                  key={step.title}
                  variants={fadeInUpVariant}
                  transition={{ delay: step.delay }}
                  className="flex-shrink-0 flex flex-col items-center text-center p-4 lg:p-6 "
                >
                  <img
                    src={step.icon}
                    alt={`${step.title} icon`}
                    className="w-16 h-16 object-contain mb-3"
                    loading="lazy"
                  />
                  <h4 className="font-inter font-semibold text-[17px] leading-[30px] text-gray-800 mb-1">
                    {step.title}
                  </h4>
                  <p className="font-inter text-[16px] leading-[24px] text-gray-600">{step.desc}</p>
                </motion.li>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <>
            <motion.img
              src={Section5OrangeBalls}
              alt="Decorative orange shapes"
              variants={fadeInUpVariant}
              transition={{ delay: 0.4 }}
              className=" absolute top-0 -left-0 -right-0 object-fill  pointer-events-none"
            />

            {/* Steps row */}
            <ol className="relative flex m-auto max-w-[1250px] justify-between pl-16 px-14  py-12 lg:py-10 overflow-x-auto lg:overflow-visible gap-6 snap-x snap-mandatory">
              {steps.map((step, idx) => (
                <motion.li
                  key={idx}
                  variants={fadeInUpVariant}
                  transition={{ delay: step.delay }}
                  className="flex-shrink-0 w-[200px] flex flex-col items-center text-center p-4 lg:p-6 "
                >
                  <img
                    src={step.icon}
                    alt={`${step.title} icon`}
                    className="w-16 h-16 object-contain mb-3"
                    loading="lazy"
                  />
                  <h4 className="font-inter font-semibold text-[17px] leading-[30px] text-gray-800 mb-1">
                    {step.title}
                  </h4>
                  <p className="font-inter text-[16px] leading-[24px] text-gray-600">{step.desc}</p>
                </motion.li>
              ))}
            </ol>
          </>
        )}

        <Button
          onClick={() => navigate('/student/register/profile-update')}
          className={'m-auto block mt-4'}
        >
          Become a Student
        </Button>
      </div>

      {/* CTA button */}
      {/* <motion.div variants={fadeInUpVariant} transition={{ delay: 1.6 }} className="-mt-20">
        <button
          onClick={() => handleModalOpen('search')}
          className="inline-flex items-center justify-center px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-xl shadow-md transition focus:outline-none focus:ring-4 focus:ring-orange-200"
        >
          Find Your Tutor
        </button>
      </motion.div> */}

      {/* Modal */}
      {modalData.isOpen && <LandingPageModal onClose={handleModalClose} type={modalData.type} />}
    </motion.section>
  )
}

export default Section5
